import api from "../api"
import { TYPE_FETCHING } from "../constants"
import { LOCAL_COMPANY_ID, LOCAL_TOKEN } from "../storage"
import axios from "axios"

export const getSurveySummary = (idSurvey) =>
  api(`surveys/${idSurvey}/summary`, TYPE_FETCHING.get, {
    company: LOCAL_COMPANY_ID(),
  })

export const getSurveyQualitative = (idSurvey) =>
  api(`surveys/${idSurvey}/questions/qualitative`, TYPE_FETCHING.get, {
    company: LOCAL_COMPANY_ID(),
  })

export const getSurveyEnps = (idSurvey) =>
  api(`surveys/${idSurvey}/questions/enps`, TYPE_FETCHING.get, {
    company: LOCAL_COMPANY_ID(),
  })

export const getQuestionApi = (idQuestion) =>
  api(`questions/${idQuestion}?relation=dimensionhassurveys`, TYPE_FETCHING.get)

export const getQuestionTypesApi = (idSurvey) =>
  api(`surveys/${idSurvey}/questiontypes`, TYPE_FETCHING.get)

export const getQuestionsMultipleChoiceApi = (idSurvey) =>
  api(`surveys/${idSurvey}/questions/multiple-choice`, TYPE_FETCHING.get)

/* export const getSegmentsApi = () => api(`segments/list`, TYPE_FETCHING.get)

export const getSurveyTypesApi = () => api(`surveytypes`, TYPE_FETCHING.get)

export const getScopeTypesApi = () => api(`scope-types`, TYPE_FETCHING.get) */

export function getSegmentsApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}segments/list`,
  })
}

export function getSurveyTypesApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveytypes`,
  })
}

export function getSurveyTypesCreateApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}surveytypes/create`,
    params: { id_company: LOCAL_COMPANY_ID() },
  })
}

export function getScopeTypesApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}scope-types`,
  })
}
